import { ACTION_TYPES } from "../actions";

const initialState = {
  currentBook: {},
  languages: [],
  literatureBooks: [],
  literatureLoading: false,
  literatureLoaded: false,
  literatureError: false,
  series: [],
  topics: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.SELECTED_BOOK_CHANGED:
      return {
        ...state,
        currentBook: action.payload,
      };
    case ACTION_TYPES.BOOK_SERIES_LOADED:
      return {
        ...state,
        series: action.payload,
      };
    case ACTION_TYPES.BOOK_TOPICS_LOADED:
      return {
        ...state,
        topics: action.payload,
      };
    case ACTION_TYPES.BOOK_LANGUAGES_LOADED:
      return {
        ...state,
        languages: action.payload,
      };
    case ACTION_TYPES.LITERATURE_ADDED:
      return {
        ...state,
        literatureBooks: [...state.literatureBooks, ...action.payload],
        literatureLoaded: true,
      };
    case ACTION_TYPES.LITERATURE_LOADED:
      return {
        ...state,
        literatureBooks: action.payload,
        literatureLoaded: true,
      };
    case ACTION_TYPES.LITERATURE_QUERY_START:
      return {
        ...state,
        literatureLoading: true,
        literatureLoaded: false,
        literatureError: false,
      };
    case ACTION_TYPES.LITERATURE_QUERY_END:
      return {
        ...state,
        literatureLoading: false,
        literatureError: action.payload.error,
      };
    default:
      return state;
  }
}
